import {REHYDRATE} from 'redux-persist/lib/constants';

import {SET_SCROLL} from '@actions/actionTypes';
import {mergeRehydrate} from '@reducers/rehydrateUtils';

const initialState = {
};

const scrollReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_SCROLL: {
            return {...state, ...{[action.params.pathname]: action.params.scrollOffset}};
        }

        case REHYDRATE: {
            return {
                ...state,
                ...mergeRehydrate(action, 'payload.app.scroll', initialState),
            };
        }

        default:
            return state;
    }
};

export default scrollReducer;
